import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaBuilding, FaArrowLeft } from 'react-icons/fa';
import { getUserRole, isContractorAdmin } from '../../../utils/roleUtils';
import { getApiEndpoint } from '../../../config/api';
import PropertyCard from '../../property/PropertyCard/PropertyCard';
import cloudsafeLogo from '../../../assets/cloudsafe-logo.png';
import './ContractorDashboard.css';

const ContractorProperties = () => {
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (getUserRole() !== 'contractor') {
      navigate('/login');
      return;
    }
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };
    fetch(getApiEndpoint('/api/properties'), { headers })
      .then(res => res.ok ? res.json() : [])
      .then(list => setProperties(list))
      .catch(() => setProperties([]))
      .finally(() => setLoading(false));
  }, [navigate]);

  const handlePropertyClick = (propertyId) => {
    navigate(`/propertydashboard/${propertyId}`);
  };

  const backRoute = isContractorAdmin() ? '/contractor/dashboard' : '/contractor/staff-dashboard';

  return (
    <div className="contractor-dashboard">
      <header className="contractor-header">
        <div className="header-left">
          <Link to={backRoute} className="mobile-menu-btn" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <FaArrowLeft /> Back
          </Link>
          <img src={cloudsafeLogo} alt="CloudSafe" className="header-logo" />
          <h1 className="header-title">Properties</h1>
        </div>
      </header>
      <main className="contractor-main" style={{ padding: '1.5rem' }}>
        <p style={{ color: '#6b7280', marginBottom: '1.25rem' }}>
          Properties your company has been given access to. Same view as the main property dashboard.
        </p>
        {loading ? (
          <div className="fm-loading"><div className="fm-spinner" /><p>Loading properties...</p></div>
        ) : properties.length === 0 ? (
          <div className="con-empty-state">
            <FaBuilding className="empty-icon" />
            <h3>No properties yet</h3>
            <p>When a Facility Manager adds your company to a property, it will appear here.</p>
          </div>
        ) : (
          <div className="properties-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1.25rem' }}>
            {properties.map(property => (
              <PropertyCard
                key={property.id}
                property={property}
                onDelete={null}
                onPropertyClick={handlePropertyClick}
                viewOnly={true}
              />
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default ContractorProperties;
